import * as styles from './Skeleton.module.css'

function Skeleton({
  Element = 'div',
  className = styles.Skeleton,
  ...restProps
}) {
  return <Element {...restProps} className={className} />
}

export default Skeleton
